<ng-container>
    <div class="px-4">
        @if(dataLoaded){
        <app-data-grid [nestedParentColumns]="nestedParentColumns" [nestedChildColumns]="nestedChildColumns" 
             [nestedTable]="true" [nestedParentDataSet]="listOfParentData"></app-data-grid>
        }
        @if(!dataLoaded){

        <app-spinner class="vh-70 d-flex justify-content-center "></app-spinner>
        }
    </div>
</ng-container>